import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { NamespacesList } from 'core/enums/common';

interface ITicketCreateTimeProps {
	createDate: string | undefined;
	updateDate: Date | undefined;
}

export const TicketUpdateTime: FC<ITicketCreateTimeProps> = ({ createDate, updateDate }) => {
	const { t: commonTranslate } = useTranslation(NamespacesList['common']);

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: window.innerWidth < 900 ? 'center' : 'flex-start',
				gap: '24px',
			}}
		>
			{createDate && (
				<Typography
					sx={{
						color: '#707A8E',
						fontSize: '12px',
						'@media (max-width: 1536px)': {
							fontSize: '10px',
						},
					}}
				>
					{commonTranslate('text.ticketCreated')}
					{createDate && format(new Date(createDate), 'dd/MM/yyyy')}
				</Typography>
			)}
			{updateDate && (
				<Typography
					sx={{
						color: '#707A8E',
						fontSize: '12px',
						'@media (max-width: 1536px)': {
							fontSize: '10px',
						},
					}}
				>
					{commonTranslate('text.ticketLastModified')}
					{updateDate ? format(new Date(updateDate), 'dd/MM/yyyy') : 'N/A'}
				</Typography>
			)}
		</Box>
	);
};
